import { apiRequest } from 'src/common/utils/apiFetch';
import { SnoozeApiResponse } from 'src/admin/common/components/SnoozeModal/types';
import { LISTING_API_PREFIX } from 'src/common/constants';

const bulkUnsnoozeListings = async (boats: string[]): Promise<SnoozeApiResponse> => {
  const url = `${LISTING_API_PREFIX}unsnooze`;
  try {
    const response = await apiRequest(url, {
      method: 'PATCH',
      body: JSON.stringify({
        data: { boats },
      }),
    });
    if (response.ok) {
      return { success: true };
    }
    return { success: false };
  } catch (error) {
    return { success: false };
  }
};

export default bulkUnsnoozeListings;
